<template>
  <div>
    <div v-if="!isAuthenticationGranted">
      <!-- nic nezobrazit -->
    </div>
    <div v-if="isAuthenticationGranted">
      <gov-button wcag-label="Košík" variant="primary" type="solid" size="m" hoverable id="gov-button-cart" class="gov-button-cart" @gov-click="cartClickHandler">
        <span class="material-icons-outlined" style="font-size: 16px; padding-top: 2px">shopping_cart</span>
        {{ this.$utils.localCurr(this.$store.state.cartSum) }}
      </gov-button>

      <b-modal ref="goToCartChoseDialog" centered hide-footer title="Pokračovat do košíku" id="goToCartChoseDialog" class="d-flex" content-class="goToCartChoseDialog-content">
        <div class="d-flex justify-content-center" style="margin-top: 1em">
          <gov-tile v-if="!this.isBusy && isGoPayPlatbyAllowed" size="m" title="Kartou" orientation="vertical" class="payByGoPayTile" clickable @click="goToCartForGoPay">
            <span slot="icon" class="material-icons-outlined payByGoPayIcon">credit_card</span>
            <div slot="title" class="d-flex flex-fill m-0 align-items-top">
              <h3 class="tile_title">{{ $t("ekopop.payment.payByCard") }}</h3>
              <gov-icon type="basic" name="chevron-right" class="tile_chevron"></gov-icon>
            </div>
          </gov-tile>

          <gov-tile v-if="!this.isBusy && isQrPlatbyAllowed" size="m" title="QR kódem" orientation="vertical" class="payByQrTile" clickable @click="goToCartForQr">
            <span slot="icon" class="material-icons-outlined payByQrIcon">qr_code</span>
            <div slot="title" class="d-flex flex-fill m-0 align-items-top">
              <h3 class="tile_title">{{ $t("ekopop.payment.payByQR") }}</h3>
              <gov-icon type="basic" name="chevron-right" class="tile_chevron"></gov-icon>
            </div>
          </gov-tile>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartControl",
  data() {
    return {
      isAuthenticationGranted: null,
      isQrPlatbyAllowed: null,
      isGoPayPlatbyAllowed: null,
      isBusy: false,
    };
  },
  mounted() {
    this.isBusy = true;
    this.$backend.getAuthenticationStatus(reponse => {
      this.isAuthenticationGranted = reponse.data.authenticationGranted;

      if (this.isAuthenticationGranted)
        this.$backend.getOrganizace(response => {
          if (response.data != null) {
            this.isQrPlatbyAllowed = response.data.qrPlatby;
            this.isGoPayPlatbyAllowed = response.data.goPayPlatby;
          }

          this.isBusy = false;
      });
    });
  },
  methods: {
    cartClickHandler() {
      if (this.isGoPayPlatbyAllowed && this.isQrPlatbyAllowed)
        this.$refs.goToCartChoseDialog.show();
      else{
        this.$store.dispatch( "selectCart" );
        if (this.$router.currentRoute.name != "cart")
          this.$router.push( {name: "cart"} );
      }
    },
    goToCartForGoPay() {
      this.$refs.goToCartChoseDialog.hide();
      this.$store.dispatch( "setCartForQr", false );
      this.$store.dispatch( "setCartForGoPay", true );
      this.$store.dispatch( "selectCart" );
      if (this.$router.currentRoute.name != "cart")
        this.$router.push( {name: "cart"} );
    },
    goToCartForQr() {
      this.$refs.goToCartChoseDialog.hide();
      this.$store.dispatch( "setCartForGoPay", false );
      this.$store.dispatch( "setCartForQr", true );
      this.$store.dispatch( "selectCart" );
      if (this.$router.currentRoute.name != "cart")
        this.$router.push( {name: "cart"} );
    },
  },
};
</script>
